<div class="app-container">
  <div class="content-secondary-buttons size">
    <button class="secondary-button" (click)="goToPasswordChangeRequired()">Cambiar contraseña</button>

    <button class="secondary-button" (click)="showClientsRequests()">Ver clientes</button>

    <button class="logout-button secondary-button" (click)="logout()">
      <img src="assets/icons/log-out.svg">
      <span>Cerrar sesión</span>
    </button>
  </div>

  <div class="content-primary-buttons size">
      @if(!!globalService.backupToPreview) {
        <button (click)="finishBackupPreview()" class="finish-backup-button">Finalizar<span class="display-none-600"> visualización de</span> backup</button>
      } @else {
        <button (click)="globalService.editing ? finishEditing() : startEditing()" class="edition-button finish-button"
          [ngClass]="{'start-button': !globalService.editing, 'finish-button': globalService.editing}">
          {{globalService.editing ? 'Finalizar' : 'Iniciar'}} edición
        </button>
      }

      <select [(ngModel)]="currentOption" name="options" id="select" class="select">
        <option [value]="options.Tokens">Tokens</option>
        <option [value]="options.Secretos">Secretos</option>
        <option [value]="options.M2M">M2M</option>
        <option [value]="options.IPs">IPs</option>
        <option [value]="options.Grupos">Grupos</option>
        <option [value]="options.Edicion">Edición</option>
        <option [value]="options.ConnectionStrings">Connection Strings</option>
        <option [value]="options.Configurations">Configuraciones</option>
        <option [value]="options.Backups">Backups</option>
        <option [value]="options.Aplicaciones">Aplicaciones</option>
        <option [value]="options.Actualizaciones">Actualizaciones</option>
      </select>
  </div>

  <div class="options-container size">
    @switch (currentOption) {
      @case(options.Tokens) { <app-tokens></app-tokens> }
      @case(options.Secretos) { <app-secretos></app-secretos> }
      @case(options.M2M) { <app-m2m></app-m2m> }
      @case(options.IPs) { <app-ips></app-ips> }
      @case(options.Grupos) { <app-grupos></app-grupos> }
      @case(options.Edicion) { <app-edicion></app-edicion> }
      @case(options.ConnectionStrings) { <app-connection-strings></app-connection-strings> }
      @case(options.Configurations) { <app-configuraciones></app-configuraciones> }
      @case(options.Backups) { <app-backups></app-backups> }
      @case(options.Aplicaciones) { <app-aplicaciones></app-aplicaciones> }
      @case(options.Actualizaciones) { <app-actualizaciones></app-actualizaciones> }
    }
  </div>
</div>